import { J as JS_PREFIX } from './built-constants-439d5572.js';

// @ts-check
/**
 * Product tile carousel selector
 */

const CAROUSEL_SELECTOR = "." + JS_PREFIX + "SlickProductTileCarousel";
/**
 * Slick carousel default configuration
 *
 * @see https://kenwheeler.github.io/slick/
 */

const DEFAULT_SLICK_CONFIG = {
  infinite: true
};
/**
 * Determines slidesToShow value
 *
 * @param {Object} breakpointData
 * @param {Number} breakpointData.windowWidth The width value of the window viewport
 * @param {Boolean} breakpointData.isFullWidth Pending the existence of a sidebar, should carousel be full width
 * @returns {Number} - How many slides to show
 */

const calcSlidesToShow = ({
  windowWidth,
  isFullWidth
}) => {
  /**
   * Responsive slide breakpoints
   *
   * - non-carousel overflow scrolling on small screens
   * - 3 product tiles with previous/arrows on medium screens
   * - 4 product tiles on large screens ( > 960 px )
   * - 5 product tiles on larger screens ( > 1280 px )
   * - 6 product tiles on even larger screens ( > 1480 )
   */
  const defaultBreakpoints = [{
    start: 0,
    end: 624,
    slidesToShow: 0
  }, {
    start: 625,
    end: 960,
    slidesToShow: 3
  }, {
    start: 961,
    end: 1280,
    slidesToShow: 4
  }, {
    start: 1281,
    end: 1480,
    slidesToShow: 5
  }, {
    start: 1481,
    end: 99999,
    slidesToShow: 6
  }]; // If you make changes here, styles/components/product-tile-carousel.scss
  // should also be modified

  const sidebarBreakpoints = [{
    start: 0,
    end: 944,
    slidesToShow: 3
  }, {
    start: 945,
    end: 1148,
    slidesToShow: 2
  }, {
    start: 1149,
    end: 1371,
    slidesToShow: 3
  }, {
    start: 1372,
    end: 1678,
    slidesToShow: 4
  }, {
    start: 1679,
    end: 99999,
    slidesToShow: 5
  }];
  /**
   * @todo This logic seems backwards. If full width, then I'd assume we want to
   * render the defaultBreakpoints. But all the carousels are using this already
   * so we may need to double-check each one and change as needed.
   */

  const slideBreakpoints = isFullWidth ? sidebarBreakpoints : defaultBreakpoints;
  const activeSlideBreakpoint = slideBreakpoints.find(breakpoint => windowWidth >= breakpoint.start && windowWidth <= breakpoint.end);
  return activeSlideBreakpoint ? activeSlideBreakpoint.slidesToShow : 0;
};
/**
 * Initializes all product tile carousels
 */


const init = () => {
  /**
   * This prevents thrown errors, if it were to be initialized twice
   */
  destroySlickCarousels();
  document.querySelectorAll(CAROUSEL_SELECTOR).forEach(el => {
    const $carousel = jQuery(el);
    /**
     * Product tile carousel button arrow svg
     */

    const arrowPreviousButton = $carousel.data('arrow-previous-button');
    const arrowNextButton = $carousel.data('arrow-next-button');
    const isFullWidth = $carousel.data('isFullWidth');
    const slidesToShow = calcSlidesToShow({
      windowWidth: jQuery(window).width(),
      isFullWidth
    });
    /**
     * Slick carousel configuration
     */

    const config = Object.assign({}, DEFAULT_SLICK_CONFIG, {
      slidesToShow,
      slidesToScroll: slidesToShow,
      prevArrow: arrowPreviousButton,
      nextArrow: arrowNextButton
    });
    /**
     * Create a slick carousel instance
     */

    if (slidesToShow > 0) {
      $carousel.not('.slick-initialized').slick(config);
    }
  });
};
/**
 * Watch for the window resize event (debounced), then initialize carousel
 */


const handleWindowResize = () => {
  let timeout = null;
  window.addEventListener('resize', () => {
    clearTimeout(timeout);
    timeout = setTimeout(init, 250);
  });
};
/**
 * Initialize carousel to start things off
 */


const initSlickCarousels = () => {
  init();
  handleWindowResize();
};
/**
 * Destroy all already initialized carousels
 * This prevents thrown errors, if it were to be initialized twice
 */

const destroySlickCarousels = () => {
  jQuery(CAROUSEL_SELECTOR + ".slick-initialized").slick('unslick');
};

export { destroySlickCarousels as d, initSlickCarousels as i };
